// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-grid-item > .react-resizable-handle {
  margin: 5px;
}

.react-grid-item .ScrollbarsCustom-Content {
  display: flex;
  flex-direction: column;
}

.react-grid-item .recharts-responsive-container {
  flex: 1 1;
}

.grid-item-body {
  overflow: auto;
  height: 100%;
}

.c-card h3 {
  margin: 0 0 10px;
}

.c-card .cart-title {
  font-size: 18px;
  font-weight: 400;
  text-align: center;
}

.c-card > .ScrollbarsCustom {
  height: 100% !important;
}

.driver-state-wrap .driver-state,
.driver-state-wrap .driver-state2 {
  margin-top: 12px;
  margin-bottom: 0;
}

.driver-state-wrap {
  margin-top: -6px;
}

.react-grid-item:hover {
  z-index: 1;
}

.recharts-tooltip-wrapper {
  z-index: 999;
}

.dashboard-layout-container {
  display: flex;
  padding-top: 60px;
}
.dashboard-layout-container .sidebar {
  width: 200px;
}
.dashboard-layout-container .sidebar p {
  margin: 10px 0;
}

.grid-container {
  position: relative;
  flex: 1 1;
  padding: 0 0 0 8px;
  border-radius: 8px;
}
.grid-container .page-heading {
  margin-top: 0;
  display: inline-flex;
  align-items: center;
}
.grid-container .page-heading a {
  margin-left: 10px;
}
.grid-container .page-heading svg {
  display: block;
}

.react-grid-layout {
  min-height: calc(100vh - 48px - 24px - 65px);
  border: 1px dashed rgba(255, 255, 255, 0.5333333333);
  border-radius: 8px;
  margin-right: 7px;
  margin-bottom: 10px;
}
.react-grid-layout.dragging {
  border: 1px solid #000;
}

.view-mode .react-grid-layout {
  min-height: inherit;
  border: 0;
  padding: 0;
  margin: 0 0 0 -4px;
}

@keyframes bounceLeft {
  0%, 20%, 50%, 80%, 100% {
    transform: translateX(-30px);
  }
  40% {
    transform: translateX(0px);
  }
  60% {
    transform: translateX(-15px);
  }
}
.dnd-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  right: 0;
  min-height: calc(50vh - 48px - 24px - 65px);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  z-index: 0;
}
.dnd-placeholder .related-icon {
  opacity: 0.25;
  margin-bottom: 16px;
}
.dnd-placeholder svg {
  vertical-align: middle;
}

.bounce-left {
  animation: bounceLeft 1.5s infinite;
}

.dashboard-layout-container a {
  z-index: 1;
  position: relative;
  display: inline-block;
}

.category-item,
.droppable-element {
  cursor: pointer;
  margin-bottom: 5px;
  padding: 3px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.category-item {
  margin-top: 0;
  margin-bottom: 5px;
}

.category-item.opened .open-icon {
  transform: rotate(180deg);
}

.overlayform {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  width: 250px;
  z-index: 999;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}
.overlayform h4 {
  margin: 0;
  padding: 6px 12px;
  display: flex;
  flex: 1 1;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
}
.overlayform svg {
  display: block;
}
.overlayform:before {
  z-index: -1;
  content: "";
  opacity: 0.7;
  display: block;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.overlayform .submit-button {
  margin-top: 50px;
}
.overlayform .form-body {
  padding: 12px;
}

.form-title-section {
  padding: 7px 10px;
  border-radius: 0;
  margin-left: -10px;
  text-align: right;
}

.dashboard-layout-container .sidebar {
  padding: 10px;
  border-radius: 0 8px 0 0;
}

:hover > .widget-actions {
  display: flex;
}

.widget-actions {
  padding: 3px;
  border-radius: 4px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  margin-top: -7px;
  margin-right: 0;
  display: none;
}
.widget-actions a ~ a {
  border-left: 1px solid #fff;
}
.widget-actions a {
  padding: 0 3px;
  display: block;
}
.widget-actions svg {
  width: 16px;
  height: 16px;
  display: block;
}

.widget-7.column-12.row-2 .driver-state2, .widget-7.column-12.row-2 .driver-state, .widget-7.column-11.row-2 .driver-state2, .widget-7.column-11.row-2 .driver-state, .widget-7.column-10.row-2 .driver-state2, .widget-7.column-10.row-2 .driver-state, .widget-7.column-9.row-2 .driver-state2, .widget-7.column-9.row-2 .driver-state, .widget-7.column-8.row-2 .driver-state2, .widget-7.column-8.row-2 .driver-state, .widget-7.column-6.row-2 .driver-state2, .widget-7.column-6.row-2 .driver-state, .widget-7.column-5.row-2 .driver-state2, .widget-7.column-5.row-2 .driver-state, .widget-7.column-4.row-2 .driver-state2, .widget-7.column-4.row-2 .driver-state, .widget-7.column-3.row-2 .driver-state2, .widget-7.column-3.row-2 .driver-state, .widget-7.column-6.row-3 .driver-state2, .widget-7.column-6.row-3 .driver-state, .widget-7.column-6.row-4 .driver-state2, .widget-7.column-6.row-4 .driver-state, .widget-7.column-6.row-5 .driver-state2, .widget-7.column-6.row-5 .driver-state, .widget-7.column-6.row-6 .driver-state2, .widget-7.column-6.row-6 .driver-state,
.widget-3.column-12.row-2 .driver-state2,
.widget-3.column-12.row-2 .driver-state,
.widget-3.column-11.row-2 .driver-state2,
.widget-3.column-11.row-2 .driver-state,
.widget-3.column-10.row-2 .driver-state2,
.widget-3.column-10.row-2 .driver-state,
.widget-3.column-9.row-2 .driver-state2,
.widget-3.column-9.row-2 .driver-state,
.widget-3.column-8.row-2 .driver-state2,
.widget-3.column-8.row-2 .driver-state,
.widget-3.column-6.row-2 .driver-state2,
.widget-3.column-6.row-2 .driver-state,
.widget-3.column-5.row-2 .driver-state2,
.widget-3.column-5.row-2 .driver-state,
.widget-3.column-4.row-2 .driver-state2,
.widget-3.column-4.row-2 .driver-state,
.widget-3.column-3.row-2 .driver-state2,
.widget-3.column-3.row-2 .driver-state,
.widget-3.column-6.row-3 .driver-state2,
.widget-3.column-6.row-3 .driver-state,
.widget-3.column-6.row-4 .driver-state2,
.widget-3.column-6.row-4 .driver-state,
.widget-3.column-6.row-5 .driver-state2,
.widget-3.column-6.row-5 .driver-state,
.widget-3.column-6.row-6 .driver-state2,
.widget-3.column-6.row-6 .driver-state {
  width: calc(25% - 12px);
}
.widget-7.column-2.row-6 h3 svg,
.widget-3.column-2.row-6 h3 svg {
  display: none !important;
}
.widget-7.column-2.row-6 .driver-state2, .widget-7.column-2.row-6 .driver-state,
.widget-3.column-2.row-6 .driver-state2,
.widget-3.column-2.row-6 .driver-state {
  padding: 10px;
  width: 100%;
  margin: 12px 0 0 12px;
}
.widget-7.column-2.row-6 .driver-state2 svg, .widget-7.column-2.row-6 .driver-state svg,
.widget-3.column-2.row-6 .driver-state2 svg,
.widget-3.column-2.row-6 .driver-state svg {
  display: none;
}
.widget-7.column-2.row-6 .driver-state2 h3, .widget-7.column-2.row-6 .driver-state h3,
.widget-3.column-2.row-6 .driver-state2 h3,
.widget-3.column-2.row-6 .driver-state h3 {
  margin: 0;
  font-size: 20px;
}
.widget-7.column-2.row-6 .driver-state2 p, .widget-7.column-2.row-6 .driver-state p,
.widget-3.column-2.row-6 .driver-state2 p,
.widget-3.column-2.row-6 .driver-state p {
  margin: 0;
}
.widget-7.column-6.row-3 h3,
.widget-3.column-6.row-3 h3 {
  margin: 0;
}
.widget-7.column-6.row-3 .driver-state2, .widget-7.column-6.row-3 .driver-state,
.widget-3.column-6.row-3 .driver-state2,
.widget-3.column-6.row-3 .driver-state {
  padding: 10px;
}
.widget-7.column-6.row-3 .driver-state2 p, .widget-7.column-6.row-3 .driver-state p,
.widget-3.column-6.row-3 .driver-state2 p,
.widget-3.column-6.row-3 .driver-state p {
  margin: 0;
}
.widget-7.column-12.row-2 h3, .widget-7.column-11.row-2 h3, .widget-7.column-10.row-2 h3, .widget-7.column-9.row-2 h3, .widget-7.column-8.row-2 h3, .widget-7.column-6.row-2 h3, .widget-7.column-5.row-2 h3, .widget-7.column-4.row-2 h3, .widget-7.column-3.row-2 h3, .widget-7.column-6.row-2 h3, .widget-7.column-2.row-5 h3, .widget-7.column-3.row-3 h3,
.widget-3.column-12.row-2 h3,
.widget-3.column-11.row-2 h3,
.widget-3.column-10.row-2 h3,
.widget-3.column-9.row-2 h3,
.widget-3.column-8.row-2 h3,
.widget-3.column-6.row-2 h3,
.widget-3.column-5.row-2 h3,
.widget-3.column-4.row-2 h3,
.widget-3.column-3.row-2 h3,
.widget-3.column-6.row-2 h3,
.widget-3.column-2.row-5 h3,
.widget-3.column-3.row-3 h3 {
  margin: 0;
}
.widget-7.column-12.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-11.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-10.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-9.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-8.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-6.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-5.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-4.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-3.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-6.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-2.row-5 .ScrollbarsCustom-Content > h3, .widget-7.column-3.row-3 .ScrollbarsCustom-Content > h3,
.widget-3.column-12.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-11.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-10.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-9.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-8.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-6.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-5.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-4.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-3.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-6.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-2.row-5 .ScrollbarsCustom-Content > h3,
.widget-3.column-3.row-3 .ScrollbarsCustom-Content > h3 {
  display: none;
}
.widget-7.column-12.row-2 .driver-state2, .widget-7.column-12.row-2 .driver-state, .widget-7.column-11.row-2 .driver-state2, .widget-7.column-11.row-2 .driver-state, .widget-7.column-10.row-2 .driver-state2, .widget-7.column-10.row-2 .driver-state, .widget-7.column-9.row-2 .driver-state2, .widget-7.column-9.row-2 .driver-state, .widget-7.column-8.row-2 .driver-state2, .widget-7.column-8.row-2 .driver-state, .widget-7.column-6.row-2 .driver-state2, .widget-7.column-6.row-2 .driver-state, .widget-7.column-5.row-2 .driver-state2, .widget-7.column-5.row-2 .driver-state, .widget-7.column-4.row-2 .driver-state2, .widget-7.column-4.row-2 .driver-state, .widget-7.column-3.row-2 .driver-state2, .widget-7.column-3.row-2 .driver-state, .widget-7.column-6.row-2 .driver-state2, .widget-7.column-6.row-2 .driver-state, .widget-7.column-2.row-5 .driver-state2, .widget-7.column-2.row-5 .driver-state, .widget-7.column-3.row-3 .driver-state2, .widget-7.column-3.row-3 .driver-state,
.widget-3.column-12.row-2 .driver-state2,
.widget-3.column-12.row-2 .driver-state,
.widget-3.column-11.row-2 .driver-state2,
.widget-3.column-11.row-2 .driver-state,
.widget-3.column-10.row-2 .driver-state2,
.widget-3.column-10.row-2 .driver-state,
.widget-3.column-9.row-2 .driver-state2,
.widget-3.column-9.row-2 .driver-state,
.widget-3.column-8.row-2 .driver-state2,
.widget-3.column-8.row-2 .driver-state,
.widget-3.column-6.row-2 .driver-state2,
.widget-3.column-6.row-2 .driver-state,
.widget-3.column-5.row-2 .driver-state2,
.widget-3.column-5.row-2 .driver-state,
.widget-3.column-4.row-2 .driver-state2,
.widget-3.column-4.row-2 .driver-state,
.widget-3.column-3.row-2 .driver-state2,
.widget-3.column-3.row-2 .driver-state,
.widget-3.column-6.row-2 .driver-state2,
.widget-3.column-6.row-2 .driver-state,
.widget-3.column-2.row-5 .driver-state2,
.widget-3.column-2.row-5 .driver-state,
.widget-3.column-3.row-3 .driver-state2,
.widget-3.column-3.row-3 .driver-state {
  padding: 10px;
}
.widget-7.column-12.row-2 .driver-state2 svg, .widget-7.column-12.row-2 .driver-state svg, .widget-7.column-11.row-2 .driver-state2 svg, .widget-7.column-11.row-2 .driver-state svg, .widget-7.column-10.row-2 .driver-state2 svg, .widget-7.column-10.row-2 .driver-state svg, .widget-7.column-9.row-2 .driver-state2 svg, .widget-7.column-9.row-2 .driver-state svg, .widget-7.column-8.row-2 .driver-state2 svg, .widget-7.column-8.row-2 .driver-state svg, .widget-7.column-6.row-2 .driver-state2 svg, .widget-7.column-6.row-2 .driver-state svg, .widget-7.column-5.row-2 .driver-state2 svg, .widget-7.column-5.row-2 .driver-state svg, .widget-7.column-4.row-2 .driver-state2 svg, .widget-7.column-4.row-2 .driver-state svg, .widget-7.column-3.row-2 .driver-state2 svg, .widget-7.column-3.row-2 .driver-state svg, .widget-7.column-6.row-2 .driver-state2 svg, .widget-7.column-6.row-2 .driver-state svg, .widget-7.column-2.row-5 .driver-state2 svg, .widget-7.column-2.row-5 .driver-state svg, .widget-7.column-3.row-3 .driver-state2 svg, .widget-7.column-3.row-3 .driver-state svg,
.widget-3.column-12.row-2 .driver-state2 svg,
.widget-3.column-12.row-2 .driver-state svg,
.widget-3.column-11.row-2 .driver-state2 svg,
.widget-3.column-11.row-2 .driver-state svg,
.widget-3.column-10.row-2 .driver-state2 svg,
.widget-3.column-10.row-2 .driver-state svg,
.widget-3.column-9.row-2 .driver-state2 svg,
.widget-3.column-9.row-2 .driver-state svg,
.widget-3.column-8.row-2 .driver-state2 svg,
.widget-3.column-8.row-2 .driver-state svg,
.widget-3.column-6.row-2 .driver-state2 svg,
.widget-3.column-6.row-2 .driver-state svg,
.widget-3.column-5.row-2 .driver-state2 svg,
.widget-3.column-5.row-2 .driver-state svg,
.widget-3.column-4.row-2 .driver-state2 svg,
.widget-3.column-4.row-2 .driver-state svg,
.widget-3.column-3.row-2 .driver-state2 svg,
.widget-3.column-3.row-2 .driver-state svg,
.widget-3.column-6.row-2 .driver-state2 svg,
.widget-3.column-6.row-2 .driver-state svg,
.widget-3.column-2.row-5 .driver-state2 svg,
.widget-3.column-2.row-5 .driver-state svg,
.widget-3.column-3.row-3 .driver-state2 svg,
.widget-3.column-3.row-3 .driver-state svg {
  display: none;
}
.widget-7.column-12.row-2 .driver-state2 h3, .widget-7.column-12.row-2 .driver-state h3, .widget-7.column-11.row-2 .driver-state2 h3, .widget-7.column-11.row-2 .driver-state h3, .widget-7.column-10.row-2 .driver-state2 h3, .widget-7.column-10.row-2 .driver-state h3, .widget-7.column-9.row-2 .driver-state2 h3, .widget-7.column-9.row-2 .driver-state h3, .widget-7.column-8.row-2 .driver-state2 h3, .widget-7.column-8.row-2 .driver-state h3, .widget-7.column-6.row-2 .driver-state2 h3, .widget-7.column-6.row-2 .driver-state h3, .widget-7.column-5.row-2 .driver-state2 h3, .widget-7.column-5.row-2 .driver-state h3, .widget-7.column-4.row-2 .driver-state2 h3, .widget-7.column-4.row-2 .driver-state h3, .widget-7.column-3.row-2 .driver-state2 h3, .widget-7.column-3.row-2 .driver-state h3, .widget-7.column-6.row-2 .driver-state2 h3, .widget-7.column-6.row-2 .driver-state h3, .widget-7.column-2.row-5 .driver-state2 h3, .widget-7.column-2.row-5 .driver-state h3, .widget-7.column-3.row-3 .driver-state2 h3, .widget-7.column-3.row-3 .driver-state h3,
.widget-3.column-12.row-2 .driver-state2 h3,
.widget-3.column-12.row-2 .driver-state h3,
.widget-3.column-11.row-2 .driver-state2 h3,
.widget-3.column-11.row-2 .driver-state h3,
.widget-3.column-10.row-2 .driver-state2 h3,
.widget-3.column-10.row-2 .driver-state h3,
.widget-3.column-9.row-2 .driver-state2 h3,
.widget-3.column-9.row-2 .driver-state h3,
.widget-3.column-8.row-2 .driver-state2 h3,
.widget-3.column-8.row-2 .driver-state h3,
.widget-3.column-6.row-2 .driver-state2 h3,
.widget-3.column-6.row-2 .driver-state h3,
.widget-3.column-5.row-2 .driver-state2 h3,
.widget-3.column-5.row-2 .driver-state h3,
.widget-3.column-4.row-2 .driver-state2 h3,
.widget-3.column-4.row-2 .driver-state h3,
.widget-3.column-3.row-2 .driver-state2 h3,
.widget-3.column-3.row-2 .driver-state h3,
.widget-3.column-6.row-2 .driver-state2 h3,
.widget-3.column-6.row-2 .driver-state h3,
.widget-3.column-2.row-5 .driver-state2 h3,
.widget-3.column-2.row-5 .driver-state h3,
.widget-3.column-3.row-3 .driver-state2 h3,
.widget-3.column-3.row-3 .driver-state h3 {
  margin: 0;
  font-size: 20px;
}
.widget-7.column-12.row-2 .driver-state2 p, .widget-7.column-12.row-2 .driver-state p, .widget-7.column-11.row-2 .driver-state2 p, .widget-7.column-11.row-2 .driver-state p, .widget-7.column-10.row-2 .driver-state2 p, .widget-7.column-10.row-2 .driver-state p, .widget-7.column-9.row-2 .driver-state2 p, .widget-7.column-9.row-2 .driver-state p, .widget-7.column-8.row-2 .driver-state2 p, .widget-7.column-8.row-2 .driver-state p, .widget-7.column-6.row-2 .driver-state2 p, .widget-7.column-6.row-2 .driver-state p, .widget-7.column-5.row-2 .driver-state2 p, .widget-7.column-5.row-2 .driver-state p, .widget-7.column-4.row-2 .driver-state2 p, .widget-7.column-4.row-2 .driver-state p, .widget-7.column-3.row-2 .driver-state2 p, .widget-7.column-3.row-2 .driver-state p, .widget-7.column-6.row-2 .driver-state2 p, .widget-7.column-6.row-2 .driver-state p, .widget-7.column-2.row-5 .driver-state2 p, .widget-7.column-2.row-5 .driver-state p, .widget-7.column-3.row-3 .driver-state2 p, .widget-7.column-3.row-3 .driver-state p,
.widget-3.column-12.row-2 .driver-state2 p,
.widget-3.column-12.row-2 .driver-state p,
.widget-3.column-11.row-2 .driver-state2 p,
.widget-3.column-11.row-2 .driver-state p,
.widget-3.column-10.row-2 .driver-state2 p,
.widget-3.column-10.row-2 .driver-state p,
.widget-3.column-9.row-2 .driver-state2 p,
.widget-3.column-9.row-2 .driver-state p,
.widget-3.column-8.row-2 .driver-state2 p,
.widget-3.column-8.row-2 .driver-state p,
.widget-3.column-6.row-2 .driver-state2 p,
.widget-3.column-6.row-2 .driver-state p,
.widget-3.column-5.row-2 .driver-state2 p,
.widget-3.column-5.row-2 .driver-state p,
.widget-3.column-4.row-2 .driver-state2 p,
.widget-3.column-4.row-2 .driver-state p,
.widget-3.column-3.row-2 .driver-state2 p,
.widget-3.column-3.row-2 .driver-state p,
.widget-3.column-6.row-2 .driver-state2 p,
.widget-3.column-6.row-2 .driver-state p,
.widget-3.column-2.row-5 .driver-state2 p,
.widget-3.column-2.row-5 .driver-state p,
.widget-3.column-3.row-3 .driver-state2 p,
.widget-3.column-3.row-3 .driver-state p {
  margin: 0;
}
.widget-7.column-12.row-2 .c-card, .widget-7.column-11.row-2 .c-card, .widget-7.column-10.row-2 .c-card, .widget-7.column-9.row-2 .c-card, .widget-7.column-8.row-2 .c-card, .widget-7.column-6.row-2 .c-card, .widget-7.column-5.row-2 .c-card, .widget-7.column-4.row-2 .c-card, .widget-7.column-3.row-2 .c-card, .widget-7.column-6.row-2 .c-card,
.widget-3.column-12.row-2 .c-card,
.widget-3.column-11.row-2 .c-card,
.widget-3.column-10.row-2 .c-card,
.widget-3.column-9.row-2 .c-card,
.widget-3.column-8.row-2 .c-card,
.widget-3.column-6.row-2 .c-card,
.widget-3.column-5.row-2 .c-card,
.widget-3.column-4.row-2 .c-card,
.widget-3.column-3.row-2 .c-card,
.widget-3.column-6.row-2 .c-card {
  display: block;
}
.widget-7.column-12.row-2 .cart-title, .widget-7.column-11.row-2 .cart-title, .widget-7.column-10.row-2 .cart-title, .widget-7.column-9.row-2 .cart-title, .widget-7.column-8.row-2 .cart-title, .widget-7.column-6.row-2 .cart-title, .widget-7.column-5.row-2 .cart-title, .widget-7.column-4.row-2 .cart-title, .widget-7.column-3.row-2 .cart-title, .widget-7.column-6.row-2 .cart-title,
.widget-3.column-12.row-2 .cart-title,
.widget-3.column-11.row-2 .cart-title,
.widget-3.column-10.row-2 .cart-title,
.widget-3.column-9.row-2 .cart-title,
.widget-3.column-8.row-2 .cart-title,
.widget-3.column-6.row-2 .cart-title,
.widget-3.column-5.row-2 .cart-title,
.widget-3.column-4.row-2 .cart-title,
.widget-3.column-3.row-2 .cart-title,
.widget-3.column-6.row-2 .cart-title {
  float: left;
}
.widget-7.column-12.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-11.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-10.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-9.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-8.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-6.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-5.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-4.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-3.row-2 .ScrollbarsCustom-Content > h3, .widget-7.column-6.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-12.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-11.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-10.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-9.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-8.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-6.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-5.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-4.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-3.row-2 .ScrollbarsCustom-Content > h3,
.widget-3.column-6.row-2 .ScrollbarsCustom-Content > h3 {
  display: flex;
  justify-content: flex-end;
  margin-top: 0;
  line-height: 1;
}
.widget-7.column-12.row-2 .ScrollbarsCustom-Content > h3 svg, .widget-7.column-11.row-2 .ScrollbarsCustom-Content > h3 svg, .widget-7.column-10.row-2 .ScrollbarsCustom-Content > h3 svg, .widget-7.column-9.row-2 .ScrollbarsCustom-Content > h3 svg, .widget-7.column-8.row-2 .ScrollbarsCustom-Content > h3 svg, .widget-7.column-6.row-2 .ScrollbarsCustom-Content > h3 svg, .widget-7.column-5.row-2 .ScrollbarsCustom-Content > h3 svg, .widget-7.column-4.row-2 .ScrollbarsCustom-Content > h3 svg, .widget-7.column-3.row-2 .ScrollbarsCustom-Content > h3 svg, .widget-7.column-6.row-2 .ScrollbarsCustom-Content > h3 svg,
.widget-3.column-12.row-2 .ScrollbarsCustom-Content > h3 svg,
.widget-3.column-11.row-2 .ScrollbarsCustom-Content > h3 svg,
.widget-3.column-10.row-2 .ScrollbarsCustom-Content > h3 svg,
.widget-3.column-9.row-2 .ScrollbarsCustom-Content > h3 svg,
.widget-3.column-8.row-2 .ScrollbarsCustom-Content > h3 svg,
.widget-3.column-6.row-2 .ScrollbarsCustom-Content > h3 svg,
.widget-3.column-5.row-2 .ScrollbarsCustom-Content > h3 svg,
.widget-3.column-4.row-2 .ScrollbarsCustom-Content > h3 svg,
.widget-3.column-3.row-2 .ScrollbarsCustom-Content > h3 svg,
.widget-3.column-6.row-2 .ScrollbarsCustom-Content > h3 svg {
  display: none !important;
}
.widget-7.column-12.row-2 .driver-state2, .widget-7.column-12.row-2 .driver-state, .widget-7.column-11.row-2 .driver-state2, .widget-7.column-11.row-2 .driver-state, .widget-7.column-10.row-2 .driver-state2, .widget-7.column-10.row-2 .driver-state, .widget-7.column-9.row-2 .driver-state2, .widget-7.column-9.row-2 .driver-state, .widget-7.column-8.row-2 .driver-state2, .widget-7.column-8.row-2 .driver-state, .widget-7.column-6.row-2 .driver-state2, .widget-7.column-6.row-2 .driver-state, .widget-7.column-5.row-2 .driver-state2, .widget-7.column-5.row-2 .driver-state, .widget-7.column-4.row-2 .driver-state2, .widget-7.column-4.row-2 .driver-state, .widget-7.column-3.row-2 .driver-state2, .widget-7.column-3.row-2 .driver-state, .widget-7.column-6.row-2 .driver-state2, .widget-7.column-6.row-2 .driver-state,
.widget-3.column-12.row-2 .driver-state2,
.widget-3.column-12.row-2 .driver-state,
.widget-3.column-11.row-2 .driver-state2,
.widget-3.column-11.row-2 .driver-state,
.widget-3.column-10.row-2 .driver-state2,
.widget-3.column-10.row-2 .driver-state,
.widget-3.column-9.row-2 .driver-state2,
.widget-3.column-9.row-2 .driver-state,
.widget-3.column-8.row-2 .driver-state2,
.widget-3.column-8.row-2 .driver-state,
.widget-3.column-6.row-2 .driver-state2,
.widget-3.column-6.row-2 .driver-state,
.widget-3.column-5.row-2 .driver-state2,
.widget-3.column-5.row-2 .driver-state,
.widget-3.column-4.row-2 .driver-state2,
.widget-3.column-4.row-2 .driver-state,
.widget-3.column-3.row-2 .driver-state2,
.widget-3.column-3.row-2 .driver-state,
.widget-3.column-6.row-2 .driver-state2,
.widget-3.column-6.row-2 .driver-state {
  font-size: 10px;
}
.widget-7.column-2.row-5 .driver-state2, .widget-7.column-2.row-5 .driver-state,
.widget-3.column-2.row-5 .driver-state2,
.widget-3.column-2.row-5 .driver-state {
  width: 100%;
}
.widget-7.column-3.row-4 h3,
.widget-3.column-3.row-4 h3 {
  margin: 0;
  line-height: 1.2;
}
.widget-7.column-3.row-4 .driver-state2, .widget-7.column-3.row-4 .driver-state, .widget-7.column-3.row-5 .driver-state2, .widget-7.column-3.row-5 .driver-state,
.widget-3.column-3.row-4 .driver-state2,
.widget-3.column-3.row-4 .driver-state,
.widget-3.column-3.row-5 .driver-state2,
.widget-3.column-3.row-5 .driver-state {
  text-align: left;
}
.widget-7.column-3.row-4 .driver-state2 svg, .widget-7.column-3.row-4 .driver-state svg, .widget-7.column-3.row-5 .driver-state2 svg, .widget-7.column-3.row-5 .driver-state svg,
.widget-3.column-3.row-4 .driver-state2 svg,
.widget-3.column-3.row-4 .driver-state svg,
.widget-3.column-3.row-5 .driver-state2 svg,
.widget-3.column-3.row-5 .driver-state svg {
  width: 24px;
  height: 24px;
  float: left;
  margin-right: 10px;
}
.widget-7.column-3.row-4 .driver-state2 h3, .widget-7.column-3.row-4 .driver-state h3, .widget-7.column-3.row-5 .driver-state2 h3, .widget-7.column-3.row-5 .driver-state h3,
.widget-3.column-3.row-4 .driver-state2 h3,
.widget-3.column-3.row-4 .driver-state h3,
.widget-3.column-3.row-5 .driver-state2 h3,
.widget-3.column-3.row-5 .driver-state h3 {
  margin: 0 0 5px;
  font-size: 24px;
}
.widget-7.column-3.row-4 .driver-state2 p, .widget-7.column-3.row-4 .driver-state p, .widget-7.column-3.row-5 .driver-state2 p, .widget-7.column-3.row-5 .driver-state p,
.widget-3.column-3.row-4 .driver-state2 p,
.widget-3.column-3.row-4 .driver-state p,
.widget-3.column-3.row-5 .driver-state2 p,
.widget-3.column-3.row-5 .driver-state p {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/Pages/DashboardBuilder/style.scss"],"names":[],"mappings":"AACA;EAA4C,WAAA;AAC5C;;AAAA;EAA4C,aAAA;EAAc,sBAAA;AAK1D;;AAJA;EAAiD,SAAA;AAQjD;;AAPA;EACI,cAAA;EACA,YAAA;AAUJ;;AAPA;EACI,gBAAA;AAUJ;;AARA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAWJ;;AARG;EACI,uBAAA;AAWP;;AARA;;EAII,gBAAA;EACA,gBAAA;AASJ;;AAPA;EACI,gBAAA;AAUJ;;AALA;EACI,UAAA;AAQJ;;AANA;EACI,YAAA;AASJ;;AANA;EACI,aAAA;EACA,iBAAA;AASJ;AARI;EACI,YAAA;AAUR;AATQ;EACI,cAAA;AAWZ;;AAPA;EACI,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;AAUJ;AATI;EACI,aAAA;EACA,oBAAA;EACA,mBAAA;AAWR;AAVQ;EACI,iBAAA;AAYZ;AAVQ;EACI,cAAA;AAYZ;;AARA;EACI,4CAAA;EACA,oDAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAWJ;AAVI;EACI,sBAAA;AAYR;;AAPI;EACI,mBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAUR;;AANA;EACI;IAME,4BAAA;EAKJ;EAHE;IAEE,0BAAA;EAKJ;EAHE;IAEE,4BAAA;EAKJ;AACF;AAHA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;AAKJ;AAJI;EACI,aAAA;EACA,mBAAA;AAMR;AAJI;EACI,sBAAA;AAMR;;AAHA;EAEI,mCAAA;AAMJ;;AAJA;EACI,UAAA;EACA,kBAAA;EACA,qBAAA;AAOJ;;AAJA;;EAEI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAOJ;;AALA;EACI,aAAA;EACA,kBAAA;AAQJ;;AALI;EACI,yBAAA;AAQR;;AALA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;EACA,uCAAA;AAQJ;AAPI;EACI,SAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,4CAAA;AASR;AAPI;EACI,cAAA;AASR;AAPI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,OAAA;EAAQ,QAAA;EAAS,SAAA;EAAU,MAAA;AAYnC;AAVI;EACI,gBAAA;AAYR;AAVI;EACI,aAAA;AAYR;;AARA;EAAsB,iBAAA;EAAmB,gBAAA;EAAkB,kBAAA;EAAoB,iBAAA;AAe/E;;AAbA;EACI,aAAA;EACA,wBAAA;AAgBJ;;AAbA;EACA,aAAA;AAgBA;;AAbA;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AAgBJ;AAfI;EACI,2BAAA;AAiBR;AAfI;EACI,cAAA;EACA,cAAA;AAiBR;AAfI;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAiBR;;AAMQ;;;;;;;;;;;;;;;;;;;;;;;;;;;EACI,uBAAA;AAuBZ;AAnBQ;;EACI,wBAAA;AAsBZ;AApBQ;;;EACI,aAAA;EACA,WAAA;EACA,qBAAA;AAwBZ;AAvBY;;;EACI,aAAA;AA2BhB;AAzBY;;;EACI,SAAA;EACA,eAAA;AA6BhB;AA3BY;;;EACI,SAAA;AA+BhB;AA1BQ;;EACI,SAAA;AA6BZ;AA3BQ;;;EACI,aAAA;AA+BZ;AA9BY;;;EACI,SAAA;AAkChB;AAjBQ;;;;;;;;;;;;;EACI,SAAA;AA+BZ;AA7BQ;;;;;;;;;;;;;EACI,aAAA;AA2CZ;AAzCQ;;;;;;;;;;;;;;;;;;;;;;;;;EACI,aAAA;AAmEZ;AAlEY;;;;;;;;;;;;;;;;;;;;;;;;;EACI,aAAA;AA4FhB;AA1FY;;;;;;;;;;;;;;;;;;;;;;;;;EACI,SAAA;EACA,eAAA;AAoHhB;AAlHY;;;;;;;;;;;;;;;;;;;;;;;;;EACI,SAAA;AA4IhB;AA9HQ;;;;;;;;;;;EACI,cAAA;AA0IZ;AAxIQ;;;;;;;;;;;EACI,WAAA;AAoJZ;AAlJQ;;;;;;;;;;;EACI,aAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;AA8JZ;AA7JY;;;;;;;;;;;EACI,wBAAA;AAyKhB;AAtKQ;;;;;;;;;;;;;;;;;;;;;EACI,eAAA;AA4LZ;AAxLQ;;;EACI,WAAA;AA4LZ;AAxLQ;;EACI,SAAA;EACA,gBAAA;AA2LZ;AArLQ;;;;;EACI,gBAAA;AA2LZ;AA1LY;;;;;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAgMhB;AA9LY;;;;;EACI,eAAA;EACA,eAAA;AAoMhB;AAlMY;;;;;EACI,SAAA;AAwMhB","sourcesContent":["@import './../../assets/variables';\n.react-grid-item > .react-resizable-handle {margin: 5px;}\n.react-grid-item .ScrollbarsCustom-Content {display: flex;flex-direction: column;}\n.react-grid-item .recharts-responsive-container {flex: 1;}\n.grid-item-body {\n    overflow: auto;\n    height: 100%;\n}\n\n.c-card h3 {\n    margin: 0 0 10px;\n}\n.c-card .cart-title {\n    font-size: 18px;\n    font-weight: 400;\n    text-align: center;\n}\n.c-card {\n   > .ScrollbarsCustom {\n       height: 100% !important;\n   }\n}\n.driver-state-wrap\n.driver-state,\n.driver-state-wrap\n.driver-state2 {\n    margin-top: 12px;\n    margin-bottom: 0;\n}\n.driver-state-wrap {\n    margin-top: -6px;\n}\n\n\n\n.react-grid-item:hover {\n    z-index: 1;\n}\n.recharts-tooltip-wrapper {\n    z-index: 999;\n}\n\n.dashboard-layout-container {\n    display: flex;\n    padding-top: 60px;\n    .sidebar {\n        width: 200px;\n        p {\n            margin: 10px 0;\n        }\n    }\n}\n.grid-container {\n    position: relative;\n    flex: 1;\n    padding: 0 0 0 8px;\n    border-radius: 8px;\n    .page-heading {\n        margin-top: 0;\n        display: inline-flex;\n        align-items: center;\n        a {\n            margin-left: 10px;\n        }\n        svg {\n            display: block;\n        }\n    }\n}\n.react-grid-layout {\n    min-height: calc(100vh - #{$headerHeight} - #{$footerHeight} - 65px);\n    border: 1px dashed #ffffff88;\n    border-radius: 8px;\n    margin-right: 7px;\n    margin-bottom: 10px;\n    &.dragging {\n        border: 1px solid #000;\n    }\n}\n\n.view-mode {\n    .react-grid-layout {\n        min-height: inherit;\n        border: 0;\n        padding: 0;\n        margin: 0 0 0 -4px;\n    }\n}\n\n@keyframes bounceLeft {\n    0%,\n    20%,\n    50%,\n    80%,\n    100% {\n      -ms-transform: translateX(-30px);\n      transform: translateX(-30px);\n    }\n    40% {\n      -ms-transform: translateX(0px);\n      transform: translateX(0px);\n    }\n    60% {\n      -ms-transform: translateX(-15px);\n      transform: translateX(-15px);\n    }\n}\n.dnd-placeholder {\n    position: absolute;\n    top: 0;\n    left: 0;\n    text-align: center;\n    right: 0;\n    min-height: calc(50vh - #{$headerHeight} - #{$footerHeight} - 65px);\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    z-index: 0;\n    .related-icon {\n        opacity: 0.25;\n        margin-bottom: 16px;\n    }\n    svg {\n        vertical-align: middle;\n    }\n}\n.bounce-left {\n    -webkit-animation: bounceLeft 1.5s infinite;\n    animation: bounceLeft 1.5s infinite;\n}\n.dashboard-layout-container a {\n    z-index: 1;\n    position: relative;\n    display: inline-block;\n}\n\n.category-item,\n.droppable-element {\n    cursor: pointer;\n    margin-bottom: 5px;\n    padding: 3px 8px;\n    font-size: 12px;\n    font-weight: 500;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.category-item {\n    margin-top: 0;\n    margin-bottom: 5px;\n}\n.category-item.opened {\n    .open-icon {\n        transform: rotate(180deg);\n    }\n}\n.overlayform {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    width: 250px;\n    z-index: 999;\n    box-shadow: 0 0 15px rgba(black, 0.5);\n    h4 {\n        margin: 0;\n        padding: 6px 12px;\n        display: flex;\n        flex: 1;\n        align-items: center;\n        justify-content: space-between;\n        border-bottom: 1px solid rgba(#000, 0.09);\n    }\n    svg {\n        display: block;\n    }\n    &:before {\n        z-index: -1;\n        content: '';\n        opacity: 0.7;\n        display: block;\n        position: fixed;\n        left: 0;right: 0;bottom: 0;top: 0;\n    }\n    .submit-button {\n        margin-top: 50px;\n    }\n    .form-body {\n        padding: 12px;\n    }\n}\n\n.form-title-section { padding: 7px 10px; border-radius: 0; margin-left: -10px; text-align: right;}\n\n.dashboard-layout-container .sidebar {\n    padding: 10px;\n    border-radius: 0 8px 0 0;\n}\n\n:hover > .widget-actions {\ndisplay: flex;\n}\n\n.widget-actions {\n    padding: 3px;\n    border-radius: 4px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: 99;\n    display: flex;\n    align-items: center;\n    margin-top: -7px;\n    margin-right: 0;\n    display: none;\n    a ~ a {\n        border-left: 1px solid #fff;\n    }\n    a {\n        padding: 0 3px;\n        display: block;\n    }\n    svg {\n        width: 16px;\n        height: 16px;\n        display: block;\n    }\n}\n\n\n\n\n// column wise styles\n.widget-7,\n.widget-3 { // units status section\n    &.column-12.row-2,\n    &.column-11.row-2,\n    &.column-10.row-2,\n    &.column-9.row-2,\n    &.column-8.row-2,\n    &.column-6.row-2,\n    &.column-5.row-2,\n    &.column-4.row-2,\n    &.column-3.row-2,\n    &.column-6.row-3,\n    &.column-6.row-4,\n    &.column-6.row-5,\n    &.column-6.row-6 {\n        .driver-state2, .driver-state {\n            width: calc(25% - 12px);\n        }\n    }\n    &.column-2.row-6 {\n        h3 svg {\n            display: none !important;\n        }\n        .driver-state2, .driver-state {\n            padding: 10px;\n            width: 100%;\n            margin: 12px 0 0 12px;\n            svg {\n                display: none\n            }\n            h3 {\n                margin: 0;\n                font-size: 20px;\n            }\n            p {\n                margin: 0;\n            }\n        }\n    }\n    &.column-6.row-3 {\n        h3 {\n            margin: 0;\n        }  \n        .driver-state2, .driver-state {\n            padding: 10px;\n            p {\n                margin: 0;\n            }\n        } \n    }\n    &.column-12.row-2,\n    &.column-11.row-2,\n    &.column-10.row-2,\n    &.column-9.row-2,\n    &.column-8.row-2,\n    &.column-6.row-2,\n    &.column-5.row-2,\n    &.column-4.row-2,\n    &.column-3.row-2,\n\n    &.column-6.row-2,\n    &.column-2.row-5,\n    &.column-3.row-3 {\n        h3 {\n            margin: 0;\n        }\n        .ScrollbarsCustom-Content > h3 {\n            display: none;\n        }\n        .driver-state2, .driver-state {\n            padding: 10px;\n            svg {\n                display: none\n            }\n            h3 {\n                margin: 0;\n                font-size: 20px;\n            }\n            p {\n                margin: 0;\n            }\n        }\n    }\n    &.column-12.row-2,\n    &.column-11.row-2,\n    &.column-10.row-2,\n    &.column-9.row-2,\n    &.column-8.row-2,\n    &.column-6.row-2,\n    &.column-5.row-2,\n    &.column-4.row-2,\n    &.column-3.row-2,\n    &.column-6.row-2 {\n        .c-card {\n            display: block;\n        }\n        .cart-title {\n            float: left;\n        }\n        .ScrollbarsCustom-Content > h3 {\n            display: flex;\n            justify-content: flex-end;\n            margin-top: 0;\n            line-height: 1;\n            svg {\n                display: none !important;\n            }\n        }\n        .driver-state2, .driver-state {\n            font-size: 10px;\n        }\n    }\n    &.column-2.row-5 {\n        .driver-state2, .driver-state {\n            width: 100%;\n        }\n    }\n    &.column-3.row-4 {\n        h3 {\n            margin: 0;\n            line-height: 1.2;\n        }\n    }\n    \n    &.column-3.row-4,\n    &.column-3.row-5 {\n        .driver-state2, .driver-state {\n            text-align: left;\n            svg {\n                width: 24px;\n                height: 24px;\n                float: left;\n                margin-right: 10px;\n            }\n            h3 {\n                margin: 0 0 5px;\n                font-size: 24px;\n            }\n            p {\n                margin: 0;\n            }\n        }\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
